import { schema } from 'normalizr';

const options = { idAttribute: '_id' };

const contactDetailTypeSchema = new schema.Entity('contactDetailTypes', {}, options);
const contactDetailTypeListSchema = [contactDetailTypeSchema];

const invoiceSchema = new schema.Entity('invoices', {}, options);
const invoiceListSchema = [invoiceSchema];

const noteSchema = new schema.Entity('notes', {}, options);
const noteListSchema = [noteSchema];

const taskSchema = new schema.Entity('tasks', {}, options);
const taskListSchema = [taskSchema];

const taskTypeSchema = new schema.Entity('taskTypes', {}, options);
const taskTypeListSchema = [taskTypeSchema];

const storeSchema = new schema.Entity('stores', {}, options);
const storeListSchema = [storeSchema];

const storeTypeSchema = new schema.Entity('storeTypes', {}, options);
const storeTypeListSchema = [storeTypeSchema];

const storeTransferSchema = new schema.Entity('storeTransfers', {}, options);
const storeTransferListSchema = [storeTransferSchema];

const customerSchema = new schema.Entity('customers', {}, options);
const customerListSchema = [customerSchema];

const couponSchema = new schema.Entity('coupons', {}, options);
const couponListSchema = [couponSchema];

const agentTypeSchema = new schema.Entity('agentTypes', {}, options);
const agentTypeListSchema = [agentTypeSchema];

const orderStatusSchema = new schema.Entity('orderStatuses', {}, options);
const orderStatusListSchema = [orderStatusSchema];

const orderItemTypeSchema = new schema.Entity('orderItemTypes', {}, options);
const orderItemTypeListSchema = [orderItemTypeSchema];

const returnTypeSchema = new schema.Entity('returnTypes', {}, options);
const returnTypeListSchema = [returnTypeSchema];

const receiveTypeSchema = new schema.Entity('receiveTypes', {}, options);
const receiveTypeListSchema = [receiveTypeSchema];

const deviceSchema = new schema.Entity('devices', {}, options);
const deviceListSchema = [deviceSchema];

const deviceTypeSchema = new schema.Entity('deviceTypes', {}, options);
const deviceTypeListSchema = [deviceTypeSchema];

const networkStatusTypeSchema = new schema.Entity('networkStatusTypes', {}, options);
const networkStatusTypeListSchema = [networkStatusTypeSchema];

const addonSchema = new schema.Entity('addons', {}, options);
const addonListSchema = [addonSchema];

const overragePriceSchema = new schema.Entity('overragePrices', {}, options);
const overragePriceListSchema = [overragePriceSchema];

const emailTypeSchema = new schema.Entity('emailTypes', {}, options);
const emailTypeListSchema = [emailTypeSchema];

const smsTypeSchema = new schema.Entity('smsTypes', {}, options);
const smsTypeListSchema = [smsTypeSchema];

const boxTypeSchema = new schema.Entity('boxTypes', {}, options);
const boxTypeListSchema = [boxTypeSchema];

const deliverySchema = new schema.Entity('deliveries', {}, options);
const deliveryListSchema = [deliverySchema];

const deliveryItemSchema = new schema.Entity('deliveryItems', {}, options);
const deliveryItemListSchema = [deliveryItemSchema];

const userSchema = new schema.Entity('users', {
  agentType: agentTypeSchema,
}, options);
const userListSchema = [userSchema];

const roleSchema = new schema.Entity('roles', {}, options);
const roleListSchema = [roleSchema];

const firebaseUserSchema = new schema.Entity('firebaseUsers', {}, options);
const firebaseUserListSchema = [firebaseUserSchema];

const contactDetailSchema = new schema.Entity('contactDetails', {
  type: contactDetailTypeSchema
}, options);
const contactDetailListSchema = [contactDetailSchema];

const activityLogSchema = new schema.Entity('activityLogs', {
  user: userSchema
}, options);
const activityLogListSchema = [activityLogSchema];

const orderSchema = new schema.Entity('orders', {
  status: orderStatusSchema,
  traveler: customerSchema,
  payer: customerSchema,
  agentType: agentTypeSchema,
  shipmentReceiveMethodType: receiveTypeSchema,
  coupon: couponSchema,
  receiveType: receiveTypeSchema,
  shipmentStore: storeSchema
}, options);
const orderListSchema = [orderSchema];

const orderItemSchema = new schema.Entity('orderItems', {
  type: orderItemTypeSchema,
  order: orderSchema,
  deviceType: deviceTypeSchema,
  returnType: returnTypeSchema,
  receiveType: receiveTypeSchema,
  addon: addonSchema,
}, options);
const orderItemListSchema = [orderItemSchema];

const paymentSchema = new schema.Entity('payments', {
  order: orderSchema,
}, options);
const paymentListSchema = [paymentSchema];

// Fixing denormilizr recursive bug
const orderItemSchemaFix = new schema.Entity('orderItems', {}, options);
const orderItemListSchemaFix = [orderItemSchemaFix];

// Fixing denormilizr recursive bug
const paymentSchemaFix = new schema.Entity('payments', {}, options);
const paymentListSchemaFix = [paymentSchemaFix];

// Fixing denormilizr recursive bug
const orderSchemaFix = new schema.Entity('orders', {}, options);
const orderListSchemaFix = [orderSchemaFix];

// Fixing denormilizr recursive bug
const userSchemaFix = new schema.Entity('users', {}, options);
const userListSchemaFix = [userSchemaFix];

export default {
  invoiceSchema,
  invoiceListSchema,
  contactDetailTypeSchema,
  contactDetailTypeListSchema,
  firebaseUserSchema,
  firebaseUserListSchema,
  contactDetailSchema,
  contactDetailListSchema,
  customerSchema,
  customerListSchema,
  userSchema,
  userListSchema,
  noteSchema,
  noteListSchema,
  taskSchema,
  taskListSchema,
  taskTypeSchema,
  taskTypeListSchema,
  storeSchema,
  storeListSchema,
  storeTypeSchema,
  storeTypeListSchema,
  storeTransferSchema,
  storeTransferListSchema,
  orderSchema,
  orderListSchema,
  orderSchemaFix,
  orderListSchemaFix,
  agentTypeSchema,
  agentTypeListSchema,
  couponSchema,
  couponListSchema,
  returnTypeSchema,
  returnTypeListSchema,
  receiveTypeSchema,
  receiveTypeListSchema,
  orderStatusSchema,
  orderStatusListSchema,
  orderItemSchema,
  orderItemListSchema,
  orderItemSchemaFix,
  orderItemListSchemaFix,
  orderItemTypeSchema,
  orderItemTypeListSchema,
  deviceSchema,
  deviceListSchema,
  deviceTypeSchema,
  deviceTypeListSchema,
  emailTypeSchema,
  emailTypeListSchema,
  addonSchema,
  addonListSchema,
  overragePriceSchema,
  overragePriceListSchema,
  smsTypeSchema,
  smsTypeListSchema,
  boxTypeSchema,
  boxTypeListSchema,
  paymentSchema,
  paymentListSchema,
  paymentSchemaFix,
  paymentListSchemaFix,
  deliverySchema,
  deliveryListSchema,
  deliveryItemSchema,
  deliveryItemListSchema,
  roleSchema,
  roleListSchema,
  activityLogSchema,
  activityLogListSchema,
  userSchemaFix,
  userListSchemaFix,
  networkStatusTypeListSchema
}